<template>
    <div class="dx-swatch-additional side-navigation-menu"
         @click="forwardClick">
        <slot />
        <div class="menu-container">
            <dx-tree-view ref="treeViewRef"
                          :items="items"
                          key-expr="path"
                          selection-mode="single"
                          :focus-state-enabled="false"
                          expand-event="click"
                          @item-click="handleItemClick"
                          width="100%" />
        </div>
    </div>
</template>

<script>
    import DxTreeView from "devextreme-vue/tree-view";
    import { navigation, sizes, hasRoutePermission } from '../scripts/helpers';
    import { store } from "../scripts/store";


    export default {
        props: {
            compactMode: Boolean
        },
        data() {
            return {
                items: this.getNavigationItems(),
                isLargeScreen: false
            };
        },
        methods: {
            forwardClick(...args) {
                this.$emit("click", args);
            },
            handleItemClick(e) {
                if (!e.itemData.path || this.compactMode)
                    return;

                e.event.stopPropagation();

                if (e.itemData.isExternalNavigation)
                    window.open(location.origin + e.itemData.path);
                    //location.href = location.origin + e.itemData.path;
                else {
                    this.$router.push({
                        path: e.itemData.path,
                        query: { sessionID: store.getters["account/sessionID"] }
                    });
                }
            },
            updateSelection() {
                if (!this.treeView) {
                    return;
                }
                this.treeView.selectItem(this.$route.path);
                this.treeView.expandItem(this.$route.path);
            },
            getNavigationItems() {
                return this._getNavigationItems(navigation());
            },
            _getNavigationItems(inItems) {
                var items = [];
                for (var i = 0; i < inItems.length; i++) {
                    var item = inItems[i];

                    if (item.path && !(/^\//.test(item.path)))
                        item.path = `/${item.path}`;

                    if (item.items)
                        item.items = this._getNavigationItems(item.items);

                    if (item.items && item.items.length == 0)
                        continue;

                    var itemRoutes = this.$router.getRoutes().filter(record => record.path == item.path);
                    if (itemRoutes.some(record => !hasRoutePermission(record)))
                        continue;

                    items.push({ ...item, expanded: this.isLargeScreen });
                }

                return items;
            },
        },
        beforeCreate() {
            this.isLargeScreen = sizes()['screen-large'];
        },
        mounted() {
            this.treeView = this.$refs["treeViewRef"] && this.$refs["treeViewRef"].instance;
            this.updateSelection();
            if (this.compactMode) {
                this.treeView.collapseAll();
            }
        },
        watch: {
            $route() {
                this.updateSelection();
            },
            compactMode() {
                if (this.compactMode) {
                    this.treeView.collapseAll();
                } else {
                    this.updateSelection();
                }
            }
        },
        components: {
            DxTreeView
        }
    };
</script>

<style lang="scss">
    @import "../dx-styles.scss";
    @import "../themes/generated/variables.additional.scss";

    .side-navigation-menu {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        height: 100%;
        width: 250px !important;

        .menu-container {
            min-height: 100%;
            display: flex;
            flex: 1;

            .dx-treeview {
                // ## Long text positioning
                white-space: nowrap;
                // ##
                // ## Icon width customization
                .dx-treeview-item {
                    padding-left: 0;
                    padding-right: 0;

                    .dx-icon {
                        width: $side-panel-min-width !important;
                        margin: 0 !important;
                    }
                }
                // ##
                // ## Arrow customization
                .dx-treeview-node {
                    padding: 0 0 !important;
                }

                .dx-treeview-toggle-item-visibility {
                    right: 10px;
                    left: auto;
                }

                .dx-rtl .dx-treeview-toggle-item-visibility {
                    left: 10px;
                    right: auto;
                }
                // ##
                // ## Item levels customization
                .dx-treeview-node {
                    &[aria-level="1"] {
                        font-weight: bold;
                        border-bottom: 1px solid $base-border-color;
                    }

                    &[aria-level="2"] .dx-treeview-item-content {
                        font-weight: normal;
                        padding: 0 $side-panel-min-width;
                    }
                }
                // ##
            }
            // ## Selected & Focuced items customization
            .dx-treeview {
                .dx-treeview-node-container {
                    .dx-treeview-node {
                        &.dx-state-selected:not(.dx-state-focused) > .dx-treeview-item {
                            background: transparent;
                        }

                        &.dx-state-selected > .dx-treeview-item * {
                            color: $base-accent;
                        }

                        &:not(.dx-state-focused) > .dx-treeview-item.dx-state-hover {
                            background-color: lighten($base-bg, 4);
                        }
                    }
                }
            }

            .dx-theme-generic .dx-treeview {
                .dx-treeview-node-container .dx-treeview-node.dx-state-selected.dx-state-focused > .dx-treeview-item * {
                    color: inherit;
                }
            }
            // ##
        }
    }
</style>
